<div class="stats-patients">
  <!-- KPI Summary -->
  <section class="stats-patients__kpis">
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.TOTAL' | translate"
      [value]="metrics?.totalPatients || 0"
      [previousValue]="metrics?.totalPatientsKpi?.previousValue || null"
      [trend]="metrics?.totalPatientsKpi?.trend || null"
      format="number"
      icon="pi-users"
      iconColor="primary"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.NEW' | translate"
      [value]="metrics?.newPatients || 0"
      [previousValue]="metrics?.newPatientsKpi?.previousValue || null"
      [trend]="metrics?.newPatientsKpi?.trend || null"
      format="number"
      icon="pi-user-plus"
      iconColor="success"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.RETURNING' | translate"
      [value]="metrics?.returningPatients || 0"
      [previousValue]="metrics?.returningPatientsKpi?.previousValue || null"
      [trend]="metrics?.returningPatientsKpi?.trend || null"
      format="number"
      icon="pi-refresh"
      iconColor="info"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.RETENTION' | translate"
      [value]="metrics?.retentionRate || 0"
      [previousValue]="metrics?.retentionRateKpi?.previousValue || null"
      [trend]="metrics?.retentionRateKpi?.trend || null"
      format="percent"
      icon="pi-heart"
      iconColor="warning"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.CHURN' | translate"
      [value]="metrics?.churnRate || 0"
      [previousValue]="metrics?.churnRateKpi?.previousValue || null"
      [trend]="metrics?.churnRateKpi?.trend || null"
      format="percent"
      icon="pi-sign-out"
      iconColor="danger"
      [loading]="loadingMetrics"
      [upIsGood]="false"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.VISITS_PER_PATIENT' | translate"
      [value]="metrics?.avgVisitsPerPatient || 0"
      [previousValue]="metrics?.avgVisitsPerPatientKpi?.previousValue || null"
      [trend]="metrics?.avgVisitsPerPatientKpi?.trend || null"
      format="number"
      icon="pi-calendar"
      iconColor="primary"
      [loading]="loadingMetrics"
      [compact]="true"
    />
    <app-kpi-card
      [title]="'STATISTICS.PATIENTS.KPIS.AVG_LTV' | translate"
      [value]="metrics?.ltv || 0"
      [previousValue]="metrics?.ltvKpi?.previousValue || null"
      [trend]="metrics?.ltvKpi?.trend || null"
      format="currency"
      icon="pi-wallet"
      iconColor="success"
      [loading]="loadingMetrics"
      [compact]="true"
    />
  </section>

  <!-- Growth Chart -->
  <section class="stats-patients__chart-section">
    <div class="stats-patients__card">
      <div class="stats-patients__card-header">
        <h2>
          <i class="pi pi-chart-line"></i>
          {{ "STATISTICS.PATIENTS.CHARTS.GROWTH.TITLE" | translate }}
        </h2>
      </div>
      <div class="stats-patients__card-body">
        <app-stat-chart
          type="line"
          [data]="growthChartData"
          [options]="growthChartOptions"
          [loading]="loadingGrowth"
          [empty]="growthData.length === 0"
          height="280px"
        />
      </div>
    </div>
  </section>

  <!-- Two Column: Segments + Age -->
  <section class="stats-patients__two-col">
    <!-- Patient Segments -->
    <div class="stats-patients__card">
      <div class="stats-patients__card-header">
        <h2>
          <i class="pi pi-chart-bar"></i>
          {{ "STATISTICS.PATIENTS.CHARTS.SEGMENTATION.TITLE" | translate }}
        </h2>
      </div>
      <div
        class="stats-patients__card-body stats-patients__card-body--centered"
      >
        <app-stat-chart
          type="bar"
          [data]="segmentChartData"
          [options]="segmentChartOptions"
          [loading]="loadingMetrics"
          height="220px"
        />
      </div>
    </div>

    <!-- Age Distribution -->
    <div class="stats-patients__card">
      <div class="stats-patients__card-header">
        <h2>
          <i class="pi pi-chart-bar"></i>
          {{ "STATISTICS.PATIENTS.CHARTS.AGE_DISTRIBUTION.TITLE" | translate }}
        </h2>
      </div>
      <div class="stats-patients__card-body">
        <app-stat-chart
          type="bar"
          [data]="ageChartData"
          [loading]="loadingAge"
          [empty]="ageDistribution.length === 0"
          height="220px"
        />
      </div>
    </div>
  </section>

  <!-- Cohort Analysis -->
  <section class="stats-patients__cohort-section">
    <div class="stats-patients__card">
      <div class="stats-patients__card-header">
        <h2>
          <i class="pi pi-table"></i>
          {{ "STATISTICS.PATIENTS.COHORT.TITLE" | translate }}
        </h2>
        <span class="stats-patients__subtitle">{{
          "STATISTICS.PATIENTS.COHORT.SUBTITLE" | translate
        }}</span>
      </div>
      <div
        class="stats-patients__card-body stats-patients__card-body--no-padding"
      >
        <div class="stats-patients__cohort-table">
          <table>
            <thead>
              <tr>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.COHORT" | translate }}</th>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.MONTH_1" | translate }}</th>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.MONTH_2" | translate }}</th>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.MONTH_3" | translate }}</th>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.MONTH_6" | translate }}</th>
                <th>{{ "STATISTICS.PATIENTS.COHORT.HEADERS.MONTH_12" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (cohort of cohorts; track cohort.cohort) {
                <tr>
                  <td class="cohort-label">{{ cohort.cohort }}</td>
                  <td>
                    <span
                      class="cohort-cell"
                      [ngClass]="getCohortCellClass(cohort.month1)"
                    >
                      {{ cohort.month1 }}%
                    </span>
                  </td>
                  <td>
                    <span
                      class="cohort-cell"
                      [ngClass]="getCohortCellClass(cohort.month2)"
                    >
                      {{ cohort.month2 }}%
                    </span>
                  </td>
                  <td>
                    <span
                      class="cohort-cell"
                      [ngClass]="getCohortCellClass(cohort.month3)"
                    >
                      {{ cohort.month3 }}%
                    </span>
                  </td>
                  <td>
                    @if (cohort.month6 > 0) {
                      <span
                        class="cohort-cell"
                        [ngClass]="getCohortCellClass(cohort.month6)"
                      >
                        {{ cohort.month6 }}%
                      </span>
                    } @else {
                      <span class="cohort-cell cohort-cell--na">-</span>
                    }
                  </td>
                  <td>
                    @if (cohort.month12 > 0) {
                      <span
                        class="cohort-cell"
                        [ngClass]="getCohortCellClass(cohort.month12)"
                      >
                        {{ cohort.month12 }}%
                      </span>
                    } @else {
                      <span class="cohort-cell cohort-cell--na">-</span>
                    }
                  </td>
                </tr>
              }
              @if (loadingCohorts) {
                @for (i of [1, 2, 3, 4, 5]; track i) {
                  <tr class="loading-row">
                    <td colspan="6">
                      <div class="skeleton"></div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
        <p class="stats-patients__cohort-note">
          {{ "STATISTICS.PATIENTS.COHORT.NOTE" | translate }}
        </p>
      </div>
    </div>
  </section>
</div>
